module.exports = __webpack_public_path__ + "static/media/6.35a7df64.jpeg";